import React from 'react'
// HEADER
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'

const HorairesEquipe = () => {
    return (
        <div className='container-fluid'>

            {/* HEADER */}
            <HeaderReturn title='Horaires' link='/homePageEquipe' />

        </div>
    )
}

export default HorairesEquipe